import React,{useState} from 'react'
import Map from "../components/Map"
import Banner from '../components/Banner'
import { useTranslation } from 'react-i18next'
import ContactInfo from '../components/ContactInfo'
import Video from "../assets/massageRoom.mp4"
import EmailSubscribeForm from '../components/EmailSubscribeForm'

const Contact = () => {
  const {t} = useTranslation();
  return (
    <div>
      <Banner videoSrc={Video} title={t('bannerTitleContact')} bannerInfo={t('elevateWellnessJourney')} buttonText={t('bookAppointent')} />
      <ContactInfo/>
      <Map/>
      {/* <EmailSubscribeForm/> */}
    </div>
  )
}

export default Contact